<template>
  <v-app theme="dark">
    <v-main class="d-flex" v-show="ready">
      <Suspense>
        <router-view/>
      </Suspense>
      <!--      <Loading/>-->
    </v-main>
  </v-app>
</template>

<script setup>
import {ref} from "vue"
import store from "@/store"
import {useRoute, useRouter} from 'vue-router'

const router = useRouter()
const route = useRoute()

const ready = ref(false)

router.isReady().then(async () => {
  if (route.query.q) {
    await store.dispatch('auth/login', {password: route.query.q})
  }
  ready.value = true
})
</script>


<style lang="less">
.v-application {
  background: radial-gradient(120% 90% at 50% 0%, #181818 0%, #080808 60%, #000 100%);
}
</style>